import type React from 'react';
import { useEffect, useState } from 'react';
import { useNotify } from './ToastNotifications';
import eventEmitter, { WS_CONNECTION_EVENTS } from '../../lib/eventEmitter';

const toastId = 'ws-reconnect';
const WebSocketStatusNotifier: React.FC = () => {
  const [status, setStatus] = useState<'disconnected' | 'reconnected'>();
  const notify = useNotify();

  useEffect(() => {
    const handleWsReConnected = () => setStatus('reconnected');
    const handleWsDisconnected = () => setStatus('disconnected');

    eventEmitter.on(WS_CONNECTION_EVENTS.RECONNECTED, handleWsReConnected);
    eventEmitter.on(WS_CONNECTION_EVENTS.DISCONNECTED, handleWsDisconnected);

    return () => {
      eventEmitter.off(WS_CONNECTION_EVENTS.RECONNECTED, handleWsReConnected);
      eventEmitter.off(WS_CONNECTION_EVENTS.DISCONNECTED, handleWsDisconnected);
    };
  }, []);

  useEffect(() => {
    if (status === 'reconnected') {
      notify('Connected: Real-time updates resumed', {
        toastId,
        type: 'success',
        autoClose: 3000,
      });
    } else if (status === 'disconnected') {
      notify('Disconnected: Attempting to restore connection...', {
        toastId,
        type: 'error',
        autoClose: false,
      });
    }
  }, [status, notify]);

  return null;
};

export default WebSocketStatusNotifier;
